export default {
  getAttendanceModelWithType(typeCode) {
    const rankA = {
      type: [
        { code: '10', title: '正常出勤' },
        { code: '30', title: '请假' },
        { code: '50', title: '出差' }
      ],
      color: '#C4D97B'
    };
    const rankB = {
      type: [{ code: '20', title: '异常' }],
      color: '#C62814'
    };
    const rankC = {
      type: [{ code: '60', title: '休息' }],
      color: ''
    };
    // 优先级 B>A>C
    const hasRankB = rankB.type.find(item => {
      return typeCode.indexOf(item.code) > -1;
    });
    if (hasRankB) {
      return rankB.color;
    }
    const hasRankA = rankA.type.find(item => {
      return typeCode.indexOf(item.code) > -1;
    });
    if (hasRankA) {
      return rankA.color;
    }
    const hasRankC = rankC.type.find(item => {
      return typeCode.indexOf(item.code) > -1;
    });
    if (hasRankC) {
      return rankC.color;
    }
  }
};
